import Vue from "vue";
import VueI18n from "vue-i18n";
import { localeEn } from "@/utils/enums";

import en_US from "./en.json";
import da_DK from "./da.json";

const messages = {
    en_US: en_US,
    da_DK: da_DK,
};

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "en_US",
    fallbackLocale: "en_US",
    messages: messages,
});

export const setLocale = (locale) => {
    i18n.locale = locale;
};

export const getLocale = () => {
    return i18n.locale || localeEn;
};

export default i18n;
